import React from "react";
import Skeleton from "./Skeleton";
import "./loaders.css";

/**
 * Placeholder for an image while it loads — prevents layout jumps.
 */
const ImageSkeleton = ({
  width = "100%",
  height = 180,
  circle = false,
  className = "",
}) => (
  <Skeleton
    width={width}
    height={height}
    circle={circle}
    className={className}
  />
);

export default ImageSkeleton;
